import React, { Children, useEffect, useState, useRef } from 'react'

import classes from "./CreateAutomation.module.css";


import Modal from '../../../../Modal/Modal';
import Button1 from '../../../Button/Button1';
import Button2 from '../../../Button/Button2';

const CreateAutomation = ({ HandleSelectAutomation, numInput, holdiayMode, supportsAdvRules }) => {
    //------------------------------- Modal Logic  ----------------------------------------------

    const ModalDialog = useRef();

    // call ref to clearStates method from child component ScheduledAction.
    const ClearStatesChildComponetRef = useRef();

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();

        //reset states for scheduled Action
        if (ClearStatesChildComponetRef.current && ClearStatesChildComponetRef.current.HandleResetAllStates) {
            // Call the child method
            ClearStatesChildComponetRef.current.HandleResetAllStates();
        }
    }
    //-------------------------------------------------------------------------------------------------

    const handleSelectAutomation = (AutomationID) => {
        HandleCloseModal();
        HandleSelectAutomation(AutomationID);
        
    }

    return (
        <>
            <Modal ref={ModalDialog} title={"Create rule"} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} style={{ minWidth: "700px", minHeight: "420.5px" }} modalLayoutStyle={{ alignItems: "center" }}>
                <div className={classes.container}>

                    <h3 style={{color:"#6e6e6e"}}>Which type of rule?</h3>
                    <br></br>

                    {/* check if number of inputs is less than 0, if so than dont show */}
                    {numInput != 0 && <Button2 style={{ 
                                    minWidth: "350px", 
                                    minHeight: "50px", 
                                    display: "flex", 
                                    justifyContent: "center", 
                                    alignItems: "center"
                                }
                            }   
                            onClick={() => handleSelectAutomation(2)}>
                        <h4 style={{ margin: 0 }}>{"IFTTT rule (Legacy)"}</h4>
                    </Button2>}

                    {/* check if number of inputs is less than 0, if so than dont show */}
                    {(numInput != 0) && <Button2 style={{ 
                                    minWidth: "350px", 
                                    minHeight: "50px", 
                                    display: "flex", 
                                    justifyContent: "center", 
                                    alignItems: "center"
                                }
                            }   
                            onClick={() => handleSelectAutomation(5)}>
                        <h4 style={{ margin: 0 }}>{"Super rule (Beta)"}</h4>
                    </Button2>}

                    <Button2 style={{ 
                                    minWidth: "350px", 
                                    minHeight: "50px", 
                                    display: "flex", 
                                    justifyContent: "center", 
                                    alignItems: "center"
                                }
                            }   
                            onClick={() => handleSelectAutomation(1)}>
                        <h4 style={{ margin: 0 }}>Smart reminder</h4>
                    </Button2>


                    <Button2 style={{ 
                                     minWidth: "350px", 
                                     minHeight: "50px", 
                                     display: "flex", 
                                     justifyContent: "center", 
                                     alignItems: "center"
                                }
                            }  
                             onClick={() => handleSelectAutomation(0)}>
                        <h4 style={{ margin: 0 }}>Permanent schedule</h4>
                    </Button2>
                   

                    {<Button2  style={{ 
                                     minWidth: "350px", 
                                     minHeight: "50px", 
                                     display: "flex", 
                                     justifyContent: "center", 
                                     alignItems: "center"
                                    }}  
                             onClick={() => handleSelectAutomation(3)}>
                        <h4 style={{ margin: 0 }}>Temporary schedule</h4>
                    </Button2>}

                    {<Button2  style={{ 
                                     minWidth: "350px", 
                                     minHeight: "50px", 
                                     display: "flex", 
                                     justifyContent: "center", 
                                     alignItems: "center"
                                    }}  
                             onClick={() => handleSelectAutomation(4)}>
                        <h4 style={{ margin: 0 }}>Site access restriction</h4>
                    </Button2>}

                </div >
            </Modal>

            <div className={classes.GroupCardContentLayout} onClick={() => HandleShowModal()}>
                <div className={`${classes.container} ${classes.rotate}`} >
                    <h2 className={classes.rotate}>+</h2>
                </div>
            </div>
        </>
    )
}

export default CreateAutomation;




